import React, { useState } from 'react';
import {
    ConfigProvider,
    theme,
    Input,
    Select,
    DatePicker,
    TimePicker,
    Button
} from 'antd';
import {
    ChevronDown,
    ChevronRight,
    Search,
    Calendar,
    X,
    Plus,
    RefreshCw,
    Clock
} from 'lucide-react';
import { LeftOutlined, RightOutlined } from "@ant-design/icons";

import Layout from '../../Layout'; // Giữ nguyên layout của bạn
import { Link } from "react-router-dom";

export default function AddRevocationForm() {
    const [isDarkMode, setIsDarkMode] = useState(false);

    // ================= STATES =================
    const [expandedSections, setExpandedSections] = useState({
        general: true,
    });

    const toggleSection = (key) => {
        setExpandedSections(prev => ({ ...prev, [key]: !prev[key] }));
    };

    // Data Bảng Thu hồi
    const [revocations, setRevocations] = useState([
        { id: 1, allocation: 'bbbg07', qty: '1', ratio: '1/1', deposit: undefined, status: undefined },
        { id: 2, allocation: undefined, qty: '', ratio: '', deposit: undefined, status: undefined },
        { id: 3, allocation: undefined, qty: '', ratio: '', deposit: undefined, status: undefined },
    ]);

    const handleAddRevocation = () => {
        setRevocations([...revocations, { id: Date.now(), allocation: undefined, qty: '', ratio: '', deposit: undefined, status: undefined }]);
    };
    const handleRemoveRevocation = (id) => {
        setRevocations(revocations.filter(r => r.id !== id));
    };

    // ================= MOCK DATA CHO CÁC Ô SELECT =================
    const allocationOptions = [
        { value: 'bbbg07', label: 'BBBG_07 (313)' },
        { value: 'bbbg08', label: 'BBBG_08 (112)' },
    ];

    const depositOptions = [
        { value: 'co', label: 'Có đặt cọc' },
        { value: 'khong', label: 'Không đặt cọc' },
    ];

    const statusOptions = [
        { value: 'dang_su_dung', label: 'Đang sử dụng' },
        { value: 'da_thanh_ly', label: 'Đã thanh lý' },
        { value: 'mat', label: 'Mất' },
        { value: 'hong', label: 'Hỏng' },
        { value: 'huy', label: 'Hủy' },
        { value: 'bao_tri', label: 'Bảo trì, sửa chữa' },
    ];

    // ================= THEME =================
    const antdThemeConfig = {
        token: {
            colorPrimary: '#3e91ab', // Màu chủ đạo của bạn
            colorBgContainer: isDarkMode ? '#1f2937' : '#ffffff',
            colorText: isDarkMode ? '#f3f4f6' : '#374151',
            colorBorder: isDarkMode ? '#4b5563' : '#d1d5db',
            borderRadius: 6,
            controlHeight: 40,
        },
        algorithm: isDarkMode ? theme.darkAlgorithm : theme.defaultAlgorithm,
    };

    const SectionHeader = ({ title, sectionKey }) => (
        <div
            onClick={() => toggleSection(sectionKey)}
            className="flex items-center gap-2 text-[#3e91ab] font-medium text-sm mb-4 mt-8 first:mt-0 cursor-pointer hover:opacity-80 transition-opacity select-none"
        >
            {expandedSections[sectionKey] ? <ChevronDown size={18} /> : <ChevronRight size={18} />}
            <span>{title}</span>
        </div>
    );

    return (
        <Layout>
            <ConfigProvider theme={antdThemeConfig}>
                <div className={`min-h-screen pb-10 transition-colors duration-300`}>

                    {/* Header cố định */}
                    <div className="bg-white dark:bg-gray-800 border-b dark:border-gray-700 px-4 md:px-6 py-4 sticky top-[64px] z-10 shadow-sm">
                        <div className="flex items-center gap-2 text-sm">
                            <Link to="/assets/recall" className="flex items-center gap-2">
                                <div className="w-6 h-6 flex items-center justify-center rounded-full bg-[#3e91ab] hover:bg-[#357f96] text-white">
                                    <LeftOutlined className="text-[10px]" />
                                </div>
                            </Link>
                            <span className="text-gray-800 dark:text-gray-200 font-medium">Thêm mới thu hồi</span>
                        </div>
                    </div>

                    {/* Nội dung form */}
                    <div className="w-full mx-auto rounded-lg shadow-sm p-4 md:p-8 mt-6 dark:bg-gray-800 bg-white border dark:border-gray-700">

                        {/* --- 1. THÔNG TIN CHUNG --- */}
                        <SectionHeader title="Thông tin chung" sectionKey="general" />
                        {expandedSections.general && (
                            <div className="flex flex-col gap-4 animate-in slide-in-from-top-2 mb-6 max-w-2xl">

                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div>
                                        <label className="text-xs text-gray-500 mb-1 block">Mã thu hồi <span className="text-red-500">*</span></label>
                                        <Input defaultValue="BBTH_44" suffix={<RefreshCw size={16} className="text-gray-400 cursor-pointer hover:text-[#3e91ab]" />} />
                                    </div>
                                    <div>
                                        <label className="text-xs text-gray-500 mb-1 block text-transparent select-none">.</label>
                                        <Input placeholder="Tên thu hồi" />
                                    </div>
                                </div>

                                <div>
                                    <label className="text-xs text-gray-500 mb-1 block">Người thu hồi</label>
                                    <Select defaultValue="huan" className="w-full" options={[{ value: 'huan', label: 'HQ_495 - Mr. Huấn' }]} allowClear />
                                </div>

                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div>
                                        <label className="text-xs text-gray-500 mb-1 block">Ngày thu hồi <span className="text-red-500">*</span></label>
                                        <DatePicker className="w-full" format="DD/MM/YYYY" placeholder="23/08/2026" suffixIcon={<Calendar size={16} className="text-gray-400" />} />
                                    </div>
                                    <div>
                                        <label className="text-xs text-gray-500 mb-1 block">Thời gian thu hồi <span className="text-red-500">*</span></label>
                                        <TimePicker className="w-full" format="HH:mm" placeholder="02:00" suffixIcon={<Clock size={16} className="text-gray-400" />} />
                                    </div>
                                </div>

                                <div>
                                    <label className="text-xs text-gray-500 mb-1 block">Địa điểm thu hồi</label>
                                    <Input defaultValue="Cty 67" />
                                </div>

                                <div>
                                    <label className="text-xs text-gray-500 mb-1 block">Lý do thu hồi</label>
                                    <Input defaultValue="g" className="focus:border-[#3e91ab] focus:ring-[#3e91ab]" />
                                </div>
                            </div>
                        )}

                        {/* --- 2. BẢNG DANH SÁCH THU HỒI --- */}
                        <div className="mt-8 animate-in slide-in-from-top-2 mb-6">
                            <div className="overflow-x-auto no-scrollbar">
                                <div className="min-w-[900px]">
                                    {/* Header Row */}
                                    <div className="grid grid-cols-[3fr_1.2fr_1fr_1.5fr_2fr_30px] gap-2 mb-2 text-xs font-medium text-gray-500 dark:text-gray-400 px-1 items-end">
                                        <span>Thu hồi cho lần cấp phát <span className="text-red-500">*</span></span>
                                        <span>Số lượng <span className="text-red-500">*</span></span>
                                        <span>Cấp phát / t...</span>
                                        <span>Đặt cọc</span>
                                        <span>Trạng thái</span>
                                        <span className="w-6"></span>
                                    </div>

                                    {/* Asset Rows */}
                                    {revocations.map((item) => (
                                        <div key={item.id} className="grid grid-cols-[3fr_1.2fr_1fr_1.5fr_2fr_30px] gap-2 mb-3 items-center">

                                            {/* Cột 1: Thu hồi cho lần cấp phát */}
                                            <Select
                                                showSearch
                                                allowClear
                                                placeholder="Chọn một"
                                                value={item.allocation}
                                                className="w-full min-w-0"
                                                suffixIcon={!item.allocation ? <Search size={14} className="text-gray-400" /> : <i className="hidden" />}
                                                options={allocationOptions}
                                            />

                                            {/* Cột 2: Số lượng */}
                                            <Input placeholder="Số lượng" value={item.qty} />

                                            {/* Cột 3: Cấp phát / tỷ lệ (Readonly) */}
                                            <Input
                                                value={item.ratio}
                                                className="bg-gray-50 dark:bg-gray-700 text-center"
                                                readOnly
                                            />

                                            {/* Cột 4: Đặt cọc */}
                                            <Select
                                                allowClear
                                                placeholder="Chọn đặt cọc"
                                                value={item.deposit}
                                                className="w-full min-w-0"
                                                options={depositOptions}
                                            />

                                            {/* Cột 5: Trạng thái */}
                                            <Select
                                                allowClear
                                                placeholder="Chọn trạng thái"
                                                value={item.status}
                                                className="w-full min-w-0"
                                                options={statusOptions}
                                            />

                                            {/* Nút Xóa */}
                                            <X size={18} className="text-gray-400 cursor-pointer hover:text-red-500 shrink-0 ml-1" onClick={() => handleRemoveRevocation(item.id)} />
                                        </div>
                                    ))}
                                </div>
                            </div>

                            <button
                                onClick={handleAddRevocation}
                                className="flex items-center justify-center w-6 h-6 rounded-full border border-[#3e91ab] text-[#3e91ab] hover:bg-[#3e91ab] hover:text-white transition-colors mt-2"
                            >
                                <Plus size={14} />
                            </button>
                        </div>

                        {/* --- FOOTER BUTTONS --- */}
                        <div className="flex gap-3 pt-6 mt-10 border-t dark:border-gray-700">
                            <Button type="primary" size="large" style={{ backgroundColor: '#3e91ab', borderColor: '#3e91ab', fontWeight: 500 }}>
                                CẬP NHẬT
                            </Button>
                            <Button size="large" className="font-medium">
                                HỦY BỎ
                            </Button>
                        </div>
                    </div>

                </div>
            </ConfigProvider>
        </Layout>
    );
}